import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

const _socialLinkedin: FunctionComponent<{ className?: string }> = ({ className }) => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 85 85'>
        <title>Linkedin</title>
        <g id='Circle_Color' data-name='Circle Color'>
            <g id='Linkedin'>
                <circle id='back' fill='#0076b2' cx='42.5' cy='42.5' r='42.5' />
                <g id='Linkedin-2' data-name='Linkedin'>
                    <path fill='#fff' d='M19.31,34.36h9.87V66.1H19.31Zm4.94-15.77a5.72,5.72,0,1,1-5.72,5.72,5.72,5.72,0,0,1,5.72-5.72' />
                    <path
                        fill='#fff'
                        d='M35.37,34.36h9.45V38.7H45a10.36,10.36,0,0,1,9.33-5.12c10,0,11.83,6.57,11.83,15.11V66.1H56.26V50.67c0-3.68-.06-8.42-5.12-8.42s-5.92,4-5.92,8.15V66.1H35.37Z'
                    />
                </g>
            </g>
        </g>
    </svg>
);

const SocialLinkedin = styled(_socialLinkedin)``;

export default SocialLinkedin;
